import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useI18n } from "../lib/i18n";
import { ArrowLeft, Calendar, User } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsDetailPage() {
  const { slug } = useParams();
  const { t, lang } = useI18n();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(`${API}/news/${slug}`)
      .then((r) => setArticle(r.data))
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="pt-32 text-center text-[#4A5568]">Loading…</div>;
  if (!article)
    return (
      <div className="pt-32 text-center">
        <Link to="/news" className="underline">
          Back to news
        </Link>
      </div>
    );

  const title = lang === "en" ? article.title_en : article.title_it;
  const body = lang === "en" ? article.body_en : article.body_it;
  const date = new Date(article.published_at).toLocaleDateString(
    lang === "en" ? "en-GB" : "it-IT",
    { day: "2-digit", month: "long", year: "numeric" }
  );

  return (
    <article className="pt-32 pb-20 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <Link
          to="/news"
          data-testid="news-back-link"
          className="inline-flex items-center gap-2 text-[#4A5568] hover:text-[#C5A059] text-xs uppercase tracking-widest mb-8"
        >
          <ArrowLeft size={14} /> {t.news.back}
        </Link>

        <p className="overline mb-5">{article.category}</p>
        <h1
          data-testid="news-detail-title"
          className="font-serif text-4xl lg:text-5xl xl:text-6xl text-[#0A1428] leading-[1.1] tracking-tight font-medium"
        >
          {title}
        </h1>

        <div className="mt-6 flex items-center gap-5 text-sm text-[#4A5568]">
          <span className="flex items-center gap-1.5">
            <User size={14} className="text-[#C5A059]" /> {t.news.by} {article.author}
          </span>
          <span className="text-[#0A1428]/20">•</span>
          <span className="flex items-center gap-1.5">
            <Calendar size={14} className="text-[#C5A059]" /> {date}
          </span>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 mt-12">
        <img src={article.image} alt={title} className="w-full h-[450px] object-cover" />
      </div>

      <div className="max-w-3xl mx-auto px-6 mt-12">
        <p className="text-[#4A5568] text-lg leading-[1.85] whitespace-pre-line">{body}</p>
      </div>
    </article>
  );
}
